import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import { AppBar, Toolbar, Button } from '@material-ui/core';
import './appbar.css';

@inject('authStore', 'viewStore')
@withRouter
@observer
class StayMenuAppBar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            loadingMessage: 'Loading...',
        }
    }

    showLoading = (message) => {
        this.setState({
            isLoading: true,
            loadingMessage: message
        })
    }

    handleSignOut = () => {
        this.props.authStore.removeAdminInfo();
        this.props.history.push('/admin/login');
    }

    render() {
        const { title } = this.props;

        return (
            <AppBar
                position='fixed'
                classes={
                    {
                        root: 'app-bar'
                    }
                }
            >
                <Toolbar>
                    <div className='app-title-container'>
                        <span className='app-title'>
                            {title}
                        </span>
                    </div>
                    <div
                        style={{
                            paddingRight: 8
                        }}
                    >
                        <span style={{ color: '#3D3935' }}>Hi, {window.localStorage.getItem('adminLoginName').replace(/['"]+/g, '')}</span>
                    </div>
                    <div style={{ width: 100 }}>
                        <Button color='primary' onClick={this.handleSignOut}>
                            Sign Out
                        </Button>
                    </div>
                </Toolbar>
            </AppBar>
        )
    }
}

export default StayMenuAppBar;